export interface EmailTemplate {
  id: number
  group: string
  subject: string
  title: string
  content: string
  links: IEmailButton[]
  automations: ILoanEmailAutomation[]
}

export interface IEmailButton {
  label: string
  url: string
  type: 'button' | 'href'
}

export interface ILoanEmailAutomation {
  id: number
  type: 'loan'
  loanStatus: Record<string, boolean>
  duration: number
  to: Record<string, boolean>
}

export const IButtonType: Record<string, any> = { button: 'Button', href: 'Link' }
